import React, { useEffect, useMemo, useState } from 'react'
import { supabase } from './supabaseClient'
import { C } from './theme'
import { precoUnitarioB2B } from './precoCliente'
import { carregarPortes } from './portes'
import { RefreshCw, Plus, Trash2, Check, Send, ExternalLink, AlertTriangle, Clock } from 'lucide-react'

// PRECOS DE MERCADO — O MESMO ECRA PARA OS DOIS LADOS.
//
// O Ruben pediu para ver, em ate 15 artigos a escolha dele, quanto e que o
// mercado espanhol pede: Amazon ES e Idealo ES. O Kaufland ja o temos
// automatico; estes dois sao escritos a mao pelo Marco, porque a Amazon exige
// uma API paga e o Idealo bloqueia robos.
//
// Um ficheiro so, dois modos. O que muda entre o admin e o cliente sao os
// botoes e as colunas editaveis; as contas da idade, as cores e o que se
// considera fresco sao as mesmas — e tem de ser, senao um dia o cliente ve
// verde onde o admin ve vermelho.
//
// A IDADE E O CENTRO DE TUDO. Um preco escrito a mao e uma fotografia: o que o
// torna util ou perigoso e saber-se de quando e. Por isso a data aparece
// sempre, com cor, e aos 10 dias a leitura deixa de existir para o cliente —
// a propria regra de acesso na base de dados nao lha devolve.

const DIAS_VIVE = 10
const DIAS_AMARELO = 3
const DIAS_VERMELHO = 7

// PROCURAR PELO EAN, PARA NAO SE ANDAR A CACAR O ARTIGO A MAO.
//
// Da primeira vez nao ha link guardado: e um clique para abrir a pesquisa do
// EAN no sitio certo, e depois cola-se o endereco do artigo. Da segunda vez em
// diante o botao abre o artigo direito.
//
// O `amazon.es/s?k=` e a pesquisa normal da Amazon, igual em todos os dominios
// deles. O do Idealo NAO FOI CONFIRMADO daqui: o Idealo responde 403 a tudo o
// que venha de um servidor (foi por isso que os precos dele sao escritos a
// mao), por isso nao ha maneira de testar o endereco sem ser num browser. Se
// ao clicar nao cair na pesquisa, e so dizer e corrige-se.
// UM LINK DO IDEALO CHEGA PARA OS CINCO PAISES.
//
// Reparei nos links que ja estavam guardados para o Lost Cherry: e sempre o
// MESMO numero de produto, so muda o dominio e o pedaco do caminho.
//
//   idealo.es/precios/6394716/...      idealo.it/prezzi/6394716/...
//   idealo.fr/prix/6394716/...         idealo.de/preisvergleich/.../6394716.html
//
// Por isso basta colar um link, qualquer um, e os outros saem dele. Poupa
// quatro pesquisas por artigo — e sao essas quatro, vezes quinze artigos, que
// decidem se isto continua preenchido daqui a um mes.
//
// O Idealo so existe nestes cinco mercados. Nao ha idealo.nl, .pl, .cz nem .sk.
const IDEALO_PAISES = { es: 'precios', it: 'prezzi', fr: 'prix', de: 'preisvergleich', at: 'preisvergleich' }

// O id e o primeiro numero longo do endereco — serve a forma com nome
// ("/precios/6394716/tom-ford-...") e a forma sem ele
// ("/preisvergleich/OffersOfProduct/6394716.html").
export function idealoIdDe(url) {
  const m = String(url || '').match(/\/(?:OffersOfProduct\/)?(\d{5,})(?:[\/.]|$)/)
  return m ? m[1] : null
}

// A forma `OffersOfProduct` e a unica que nao precisa do nome do artigo, que e
// diferente em cada lingua. Mantem-se o endereco original do pais que ele
// colou — esse sabemos que funciona, foi de la que veio.
export function linksIdealoDeId(id, original) {
  if (!id) return {}
  const out = {}
  for (const [sf, caminho] of Object.entries(IDEALO_PAISES)) {
    out[sf] = `https://www.idealo.${sf}/${caminho}/OffersOfProduct/${id}.html`
  }
  if (original) {
    const m = String(original).match(/^https?:\/\/www\.idealo\.([a-z]{2})\//)
    if (m && out[m[1]]) out[m[1]] = original
  }
  return out
}

// A AMAZON PROCURA MAL POR EAN.
//
// O Idealo indexa o EAN e acerta quase sempre. A Amazon so o encontra quando
// algum vendedor o pos na ficha, o que em perfumaria e irregular — e uma
// pesquisa vazia manda a pessoa escrever o nome a mao, que e precisamente o
// trabalho que este atalho existe para poupar. Por isso ha dois: o EAN, que
// quando acerta acerta no artigo exacto, e o nome, que raramente volta vazio.
const procurarAmazon = (ean) => `https://www.amazon.es/s?k=${encodeURIComponent(ean || '')}`
const procurarAmazonNome = (nome) => `https://www.amazon.es/s?k=${encodeURIComponent(String(nome || '').trim())}`
// A PESQUISA DO IDEALO VAI PELO GOOGLE, DE PROPOSITO.
//
// A primeira versao apontava para a pesquisa interna deles
// (`/precios/MainSearchProductCategory.html?q=`). Era um palpite — o Idealo
// responde 403 a qualquer pedido vindo de um servidor, por isso nao havia como
// testar sem ser num browser — e estava errado: devolve "Esta pagina ya no
// existe" (confirmado pelo Marco a 11/10/2026).
//
// Em vez de adivinhar outra vez o endereco interno deles, que pode mudar
// quando lhes apetecer, pergunta-se ao Google so dentro do idealo.es. O EAN
// esta indexado nas fichas, cai-se na pagina do produto, e isto nao depende de
// nenhuma convencao que nao controlamos.
const procurarIdealo = (ean) => `https://www.google.com/search?q=${encodeURIComponent('site:idealo.es ' + (ean || ''))}`
const procurarIdealoNome = (nome) => `https://www.google.com/search?q=${encodeURIComponent('site:idealo.es ' + String(nome || '').trim())}`

const fmt = (n) => (n == null || !Number.isFinite(Number(n))) ? '—'
  : Number(n).toLocaleString('pt-PT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const diasDesde = (iso) => iso ? (Date.now() - new Date(iso).getTime()) / 86400000 : null

// Verde ate 3 dias, amarelo ate 7, vermelho ate 10. Depois disso o cliente nem
// chega a ver a linha — so o admin, para saber o que tem de actualizar.
function corDaIdade(iso) {
  const d = diasDesde(iso)
  if (d == null) return { cor: C.textFaint, texto: 'sem preço' }
  const quando = new Date(iso).toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit' })
  if (d < DIAS_AMARELO) return { cor: C.success, texto: quando }
  if (d < DIAS_VERMELHO) return { cor: '#d97706', texto: quando }
  if (d < DIAS_VIVE) return { cor: C.danger, texto: quando }
  return { cor: C.danger, texto: `${quando} · expirado` }
}

function Atalho({ href, children, titulo }) {
  return (
    <a href={href} target="_blank" rel="noreferrer" title={titulo}
       style={{ fontSize: 10.5, color: '#2563eb', textDecoration: 'none', whiteSpace: 'nowrap' }}>
      {children} <ExternalLink size={9} style={{ verticalAlign: '-1px' }} />
    </a>
  )
}

export default function VigiaMercado({ modo = 'cliente', clienteId = null }) {
  const ehAdmin = modo === 'admin'
  const [loading, setLoading] = useState(true)
  const [erro, setErro] = useState('')
  const [aviso, setAviso] = useState('')
  const [linhas, setLinhas] = useState([])
  const [precos, setPrecos] = useState(new Map())   // vigia_id -> { amazon_es, idealo_es }
  const [produtos, setProdutos] = useState(new Map())
  const [rascunho, setRascunho] = useState({})       // edicoes por linha, antes de guardar
  const [aGuardar, setAGuardar] = useState(false)
  // Seleccao em massa dos pedidos. Com 14 artigos de uma vez, aceitar um a um
  // sao 14 cliques e 14 idas a base — e o Marco fica a olhar para a lista a
  // encolher de linha em linha.
  const [escolhidos, setEscolhidos] = useState(new Set())
  const [aRever, setAReder] = useState(new Map())   // vigia_id -> {de, para, var}
  const [procura, setProcura] = useState('')
  const [candidatos, setCandidatos] = useState([])
  const [euId, setEuId] = useState(null)
  const [perfilCliente, setPerfilCliente] = useState(null)
  const [fornecedores, setFornecedores] = useState(new Map())
  const [portesUn, setPortesUn] = useState(1.00)

  const carregar = async () => {
    setLoading(true); setErro('')
    try {
      const { data: sess } = await supabase.auth.getUser()
      const meuId = sess?.user?.id || null
      setEuId(meuId)
      // O PRECO TEM DE SER O DELE, NAO O DE CATALOGO.
      // Ele pediu-o ("podes colocar pelo menos o preco aqui?") e tinha razao:
      // sem ele a tabela mostra o mercado e esconde a margem, que e a unica
      // coisa que o faz decidir. Precisa do perfil (desconto e portes) e do
      // fornecedor (ha quem venda a tabela e nao leve desconto).
      const alvo = clienteId || meuId
      if (alvo) {
        const [{ data: perf }, { data: forns }, portes] = await Promise.all([
          supabase.from('perfis').select('desconto_percentagem, portes_por_unidade, tipo_cliente').eq('id', alvo).maybeSingle(),
          supabase.from('fornecedores').select('id, permite_desconto, portes_cobrados_por_unidade'),
          carregarPortes(supabase),
        ])
        setPerfilCliente(perf || null)
        setFornecedores(new Map((forns || []).map(f => [f.id, f])))
        setPortesUn(portes.cobrados)
      }

      let q = supabase.from('vigia_mercado').select('*').neq('estado', 'removido').order('criado_em')
      if (clienteId) q = q.eq('cliente_id', clienteId)
      const { data: vs, error: e1 } = await q
      if (e1) throw e1
      setLinhas(vs || [])
      if ((vs || []).length > 0) {
        const ids = vs.map(v => v.id)
        const { data: ps } = await supabase.from('vigia_mercado_precos')
          .select('*').in('vigia_id', ids).order('lido_em', { ascending: false })
        // O actual de cada fonte e o mais recente. A tabela guarda todas as
        // leituras de proposito: a serie sai de graca e vale mais do que a
        // fotografia ("129,90, era 139 ha uma semana").
        //
        // No modo cliente deita-se fora o que ja passou dos 10 dias. A regra de
        // acesso na base ja o faz para o cliente, mas o ADMIN ve tudo — e e com
        // a conta dele que se experimenta o "ver como cliente". Sem esta linha,
        // o ensaio mostrava precos velhos que o cliente nao ve, e era o ensaio
        // que estava a mentir.
        const m = new Map()
        for (const p of (ps || [])) {
          if (!ehAdmin) {
            const d = diasDesde(p.lido_em)
            if (d == null || d >= DIAS_VIVE) continue
          }
          const atual = m.get(p.vigia_id) || {}
          if (!atual[p.fonte]) { atual[p.fonte] = p; m.set(p.vigia_id, atual) }
        }
        // ── QUAIS E QUE PRECISAM DE SER REVISTOS ──────────────────────────
        //
        // Os precos escritos a mao envelhecem todos ao mesmo ritmo, por isso a
        // cor da data nao distingue o artigo onde o mercado mexeu daquele onde
        // esta tudo na mesma. Resultado: para nao falhar nenhum, revia-se os
        // quinze — e rever quinze todas as semanas e o que faz isto deixar de
        // ser feito.
        //
        // O Kaufland le-se sozinho tres vezes por dia. Se ELE mexeu desde o dia
        // em que o preco foi escrito a mao, e sinal de que a Amazon e o Idealo
        // provavelmente tambem mexeram. E so esses que vale a pena reabrir.
        const rever = new Map()
        for (const [vid, fontes] of m) {
          const k = fontes.kaufland_es
          const manual = fontes.amazon_es || fontes.idealo_es
          if (!k?.preco || !manual?.lido_em) continue
          // O Kaufland que estava la no dia em que ele escreveu o preco.
          const antes = (ps || [])
            .filter(x => x.vigia_id === vid && x.fonte === 'kaufland_es' && x.preco
                      && new Date(x.lido_em) <= new Date(manual.lido_em))
            .sort((a, b) => new Date(b.lido_em) - new Date(a.lido_em))[0]
          if (!antes?.preco) continue
          const var_ = (Number(k.preco) - Number(antes.preco)) / Number(antes.preco)
          if (Math.abs(var_) >= 0.10) rever.set(vid, { de: Number(antes.preco), para: Number(k.preco), var: var_ })
        }
        setAReder(rever)
        setPrecos(m)
        const prodIds = [...new Set(vs.map(v => v.produto_id))]
        const { data: prs } = await supabase.from('Produtos')
          .select('id, Nome, EAN, preco, fornecedor_id, foto_url, visivel_catalogo, "Email_Cliente"').in('id', prodIds)
        setProdutos(new Map((prs || []).map(p => [p.id, p])))
      } else { setPrecos(new Map()); setProdutos(new Map()) }
    } catch (e) {
      setErro('Não consegui ler os preços de mercado: ' + (e?.message || String(e)))
    } finally { setLoading(false) }
  }
  useEffect(() => { carregar() }, [clienteId])

  const activos = useMemo(() => linhas.filter(l => l.estado === 'activo'), [linhas])
  const propostos = useMemo(() => linhas.filter(l => l.estado === 'proposto'), [linhas])
  const ocupados = linhas.length

  // ── Procurar artigos para acrescentar ────────────────────────────────────
  // So artigos do catalogo e visiveis. Os exclusivos de outro cliente nem
  // aparecem — a regra de acesso na base ja os recusaria, mas deixar o nome
  // aparecer no ecra ja seria mostrar o catalogo privado de outra pessoa.
  useEffect(() => {
    let vivo = true
    const t = setTimeout(async () => {
      const s = procura.trim()
      if (s.length < 3) { setCandidatos([]); return }
      const jaLa = new Set(linhas.map(l => l.produto_id))
      // POR NOME E POR EAN. Ele perguntou "a pesquisa funciona por nome ou
      // ean?" — so por nome, e num catalogo de perfumes o EAN e muitas vezes a
      // unica forma de acertar no artigo certo (ha seis "Libre" diferentes).
      const soDigitos = /^[0-9]{6,}$/.test(s)
      let q = supabase.from('Produtos').select('id, Nome, EAN, preco, fornecedor_id, "Email_Cliente"')
      // NAO SE FILTRA POR `visivel_catalogo`.
      //
      // Filtrava-se, e escondia-lhe justamente os artigos que ele compra: dos
      // 15 exclusivos dele, 8 estao fora do catalogo geral — o CE Ferulic, o
      // Oud Wood, o Sauvage. Ele reparou e tinha razao.
      //
      // Quem decide o que ele pode ver e a regra de acesso da Produtos, que ja
      // lhe da os artigos publicos mais os que tem o email dele. Repetir aqui
      // um filtro mais apertado do que essa regra so servia para lhe esconder
      // o que e dele.
      q = soDigitos ? q.eq('EAN', Number(s)) : q.ilike('Nome', `%${s}%`)
      const { data } = await q.limit(12)
      if (!vivo) return
      setCandidatos((data || []).filter(p => !jaLa.has(p.id)))
    }, 300)
    return () => { vivo = false; clearTimeout(t) }
  }, [procura, linhas])

  const propor = async (produtoId) => {
    if (ocupados >= 15) { setErro('Já tens 15 artigos em análise. Tira um da lista antes de acrescentar outro.'); return }
    setAGuardar(true)
    const alvo = clienteId || euId
    const { error } = await supabase.from('vigia_mercado').insert({
      cliente_id: alvo, produto_id: produtoId,
      estado: ehAdmin ? 'activo' : 'proposto',
      criado_por: ehAdmin ? 'admin' : 'cliente',
    })
    setAGuardar(false)
    if (error) { setErro(error.message); return }
    setProcura(''); setCandidatos([])
    setAviso(ehAdmin ? 'Artigo acrescentado.' : 'Pedido enviado. Assim que tiver os preços, ficas a saber por email.')
    carregar()
  }

  const remover = async (id) => {
    const { error } = await supabase.from('vigia_mercado').update({ estado: 'removido' }).eq('id', id)
    if (error) { setErro(error.message); return }
    carregar()
  }

  // ACEITAR OU RECUSAR OS QUE ESTAO MARCADOS, DE UMA VEZ.
  // Um `update ... in (ids)` em vez de um por linha: uma ida a base e a lista
  // nao pisca. Se falhar, falha inteiro e nada fica meio aceite.
  const decidirEscolhidos = async (estado) => {
    const ids = propostos.filter(l => escolhidos.has(l.id)).map(l => l.id)
    if (ids.length === 0) return
    setAGuardar(true)
    const { error } = await supabase.from('vigia_mercado').update({ estado }).in('id', ids)
    setAGuardar(false)
    if (error) { setErro(error.message); return }
    setEscolhidos(new Set())
    setAviso(`${ids.length} ${ids.length === 1 ? 'artigo' : 'artigos'} ${estado === 'activo' ? 'aceite' + (ids.length > 1 ? 's' : '') : 'recusado' + (ids.length > 1 ? 's' : '')}.`)
    carregar()
  }

  const pedirActualizacao = async (id) => {
    const { error } = await supabase.from('vigia_mercado')
      .update({ pedido_actualizacao_em: new Date().toISOString() }).eq('id', id)
    if (error) { setErro(error.message); return }
    setAviso('Pedido enviado. O Marco é avisado dentro da próxima hora.')
    carregar()
  }

  // ── Admin: guardar precos ────────────────────────────────────────────────
  const guardarLinha = async (l) => {
    const r = rascunho[l.id] || {}
    const linhasNovas = []
    const agora = new Date().toISOString()
    for (const fonte of ['amazon_es', 'idealo_es']) {
      const valor = r[fonte]
      if (valor === undefined || valor === '') continue
      const n = Number(String(valor).replace(',', '.'))
      if (!Number.isFinite(n) || n <= 0) { setErro(`Preço inválido em ${fonte === 'amazon_es' ? 'Amazon' : 'Idealo'}.`); return }
      linhasNovas.push({
        vigia_id: l.id, fonte, preco: Math.round(n * 100) / 100,
        amazon_bb_propria: fonte === 'amazon_es' ? !!r.amazon_bb_propria : false,
        lido_em: agora, criado_por: 'admin',
      })
    }
    setAGuardar(true)
    if (linhasNovas.length > 0) {
      const { error } = await supabase.from('vigia_mercado_precos').insert(linhasNovas)
      if (error) { setAGuardar(false); setErro(error.message); return }
    }
    if (r.amazon_url !== undefined || r.idealo_url !== undefined) {
      const campos = {}
      if (r.amazon_url !== undefined) campos.amazon_url = r.amazon_url || null
      if (r.idealo_url !== undefined) campos.idealo_url = r.idealo_url || null
      await supabase.from('vigia_mercado').update(campos).eq('id', l.id)

      // UM LINK COLADO ENCHE OS CINCO PAISES.
      // O relatorio por pais le os links do `config_sistema.idealo_links`, e
      // ate hoje so la estava o Lost Cherry, metido a mao. Em vez de pedir
      // cinco links por artigo — que ninguem preenche ao fim de duas semanas —
      // deriva-se do unico que ele colou.
      const ean = String(produtos.get(l.produto_id)?.EAN || '').trim()
      const id = idealoIdDe(r.idealo_url)
      if (ean && id) {
        try {
          const { data: cfgRow } = await supabase.from('config_sistema')
            .select('valor').eq('chave', 'idealo_links').maybeSingle()
          const mapa = JSON.parse(cfgRow?.valor || '{}') || {}
          // So se mexe no EAN deste artigo. Reescrever o objecto inteiro a
          // partir de uma leitura velha apagava os links de outro artigo se
          // alguem tivesse gravado entretanto.
          mapa[ean] = linksIdealoDeId(id, r.idealo_url)
          await supabase.from('config_sistema')
            .upsert({ chave: 'idealo_links', valor: JSON.stringify(mapa) }, { onConflict: 'chave' })
          setAviso(`Link do Idealo guardado — e os dos outros 4 países sairam dele (produto ${id}).`)
        } catch (e) {
          // Nao e motivo para falhar o que importa: o preco ja foi gravado.
          setAviso('Preços guardados. Os links por país do Idealo não foram: ' + (e?.message || String(e)))
        }
      }
    }
    setAGuardar(false)
    setRascunho(prev => ({ ...prev, [l.id]: {} }))
    carregar()
  }

  // NA MAIOR PARTE DOS DIAS OS PRECOS NAO MEXEM. Sem este botao, manter isto
  // vivo eram 30 numeros reescritos de semana a semana — e um campo manual que
  // da trabalho a mais deixa de ser preenchido ao fim de duas semanas. Um
  // clique copia as ultimas leituras com a data de hoje.
  const confirmarTudoIgual = async () => {
    const agora = new Date().toISOString()
    const novos = []
    for (const l of activos) {
      const p = precos.get(l.id) || {}
      for (const fonte of ['amazon_es', 'idealo_es']) {
        const ult = p[fonte]
        if (!ult || ult.preco == null) continue
        novos.push({
          vigia_id: l.id, fonte, preco: ult.preco,
          amazon_bb_propria: !!ult.amazon_bb_propria,
          lido_em: agora, criado_por: 'admin', nota: 'confirmado sem alteracao',
        })
      }
    }
    if (novos.length === 0) { setErro('Não há preços anteriores para confirmar.'); return }
    setAGuardar(true)
    const { error } = await supabase.from('vigia_mercado_precos').insert(novos)
    setAGuardar(false)
    if (error) { setErro(error.message); return }
    setAviso(`${novos.length} preços confirmados com a data de hoje.`)
    carregar()
  }

  const publicar = async () => {
    setAGuardar(true)
    const agora = new Date().toISOString()
    const ids = activos.map(l => l.id)
    if (ids.length === 0) { setAGuardar(false); setErro('Não há artigos activos para publicar.'); return }
    const { error } = await supabase.from('vigia_mercado').update({ publicado_em: agora }).in('id', ids)
    if (error) { setAGuardar(false); setErro(error.message); return }
    try {
      const { data: s } = await supabase.auth.getSession()
      const r = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/vigia-mercado-avisos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${s?.session?.access_token || ''}` },
        body: JSON.stringify({ publicar: true, cliente_id: clienteId || undefined }),
      })
      const j = await r.json()
      setAviso(j?.clientes_avisados > 0 ? 'Publicado. O cliente foi avisado por email.' : 'Publicado, mas o email não saiu — vê os registos da função.')
    } catch (e) {
      setAviso('Publicado, mas o email não saiu: ' + (e?.message || String(e)))
    }
    setAGuardar(false)
    carregar()
  }

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: C.textMuted }}>A carregar…</div>

  // ── O que o cliente vê ───────────────────────────────────────────────────
  // Uma linha so aparece se estiver publicada e com preco fresco. A regra de
  // acesso na base ja nao devolve precos com mais de 10 dias; aqui trata-se do
  // caso de nao haver nenhum, para o cliente perceber o que se passa em vez de
  // ver uma tabela vazia.
  const visiveisAoCliente = activos.filter(l => {
    if (!l.publicado_em) return false
    const p = precos.get(l.id) || {}
    return !!(p.amazon_es || p.idealo_es)
  })
  // OS QUE PRECISAM DE ATENCAO APARECEM PRIMEIRO.
  // Do lado do admin isto e uma lista de trabalho, nao um relatorio: o que
  // falta fazer tem de estar em cima, senao faz-se scroll e esquece-se.
  const paraMostrar = ehAdmin
    ? [...activos].sort((a, b) => (aRever.has(b.id) ? 1 : 0) - (aRever.has(a.id) ? 1 : 0))
    : visiveisAoCliente

  return (
    <div style={{ padding: ehAdmin ? 0 : '20px', maxWidth: '1100px', margin: '0 auto' }}>
      {!ehAdmin && (
        <div style={{ marginBottom: 14 }}>
          <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: C.text }}>Preços de mercado</h2>
          <div style={{ fontSize: 12, color: C.textMuted }}>
            O que o mercado espanhol está a pedir pelos artigos que escolheste. Cada preço mostra o dia em que foi recolhido.
          </div>
        </div>
      )}
      {erro && <div style={{ background: '#fef2f2', border: '1px solid #fecaca', color: C.danger, padding: '10px 14px', borderRadius: 6, marginBottom: 12, fontSize: 13 }}>{erro}</div>}
      {aviso && <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', color: C.success, padding: '10px 14px', borderRadius: 6, marginBottom: 12, fontSize: 13 }}>{aviso}</div>}

      {ehAdmin && (
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center', marginBottom: 12 }}>
          <button onClick={confirmarTudoIgual} disabled={aGuardar} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '7px 12px', border: `1px solid ${C.border}`, borderRadius: 6, background: C.surface, cursor: 'pointer', fontSize: 12 }}>
            <Check size={13} /> Está tudo igual
          </button>
          <button onClick={publicar} disabled={aGuardar} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '7px 12px', border: 'none', borderRadius: 6, background: C.primary, color: '#fff', cursor: 'pointer', fontSize: 12 }}>
            <Send size={13} /> Publicar e avisar
          </button>
          <button onClick={carregar} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '7px 12px', border: `1px solid ${C.border}`, borderRadius: 6, background: C.surface, cursor: 'pointer', fontSize: 12 }}>
            <RefreshCw size={13} /> Recarregar
          </button>
          {aRever.size > 0 && (
            <span style={{ fontSize: 12, fontWeight: 700, color: '#92400e', background: '#fffbeb',
                           border: '1px solid #fde68a', borderRadius: 5, padding: '4px 10px' }}>
              ⚠ {aRever.size} {aRever.size === 1 ? 'artigo precisa' : 'artigos precisam'} de ser {aRever.size === 1 ? 'revisto' : 'revistos'}
            </span>
          )}
          <span style={{ fontSize: 11.5, color: C.textMuted, marginLeft: 'auto' }}>{ocupados} de 15 · verde até {DIAS_AMARELO} dias, vermelho a partir de {DIAS_VERMELHO}, desaparece aos {DIAS_VIVE}</span>
        </div>
      )}

      {propostos.length > 0 && ehAdmin && (() => {
        const n = escolhidos.size
        const todos = n === propostos.length
        const btn = (cor, texto, accao, activo) => (
          <button onClick={accao} disabled={!activo || aGuardar}
            style={{ padding: '5px 12px', border: cor === 'branco' ? `1px solid ${C.border}` : 'none', borderRadius: 5,
                     background: cor === 'branco' ? C.surface : cor, color: cor === 'branco' ? C.text : '#fff',
                     cursor: (activo && !aGuardar) ? 'pointer' : 'not-allowed', opacity: activo ? 1 : 0.45,
                     fontSize: 12, fontWeight: 700 }}>{texto}</button>
        )
        return (
          <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, padding: '10px 14px', marginBottom: 12 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
              <strong style={{ fontSize: 12.5, color: '#92400e' }}>
                {propostos.length} artigo{propostos.length > 1 ? 's' : ''} pedido{propostos.length > 1 ? 's' : ''} pelo cliente
              </strong>
              <label style={{ fontSize: 11.5, color: '#92400e', display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
                <input type="checkbox" checked={todos}
                  onChange={e => setEscolhidos(e.target.checked ? new Set(propostos.map(l => l.id)) : new Set())} />
                {todos ? 'nenhum' : 'todos'}
              </label>
              <span style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
                {btn(C.success, n > 0 ? `Aceitar ${n}` : 'Aceitar', () => decidirEscolhidos('activo'), n > 0)}
                {btn('branco', n > 0 ? `Recusar ${n}` : 'Recusar', () => decidirEscolhidos('removido'), n > 0)}
              </span>
            </div>
            {propostos.map(l => {
              const prod = produtos.get(l.produto_id) || {}
              const marcado = escolhidos.has(l.id)
              return (
                <label key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 6, fontSize: 13, cursor: 'pointer' }}>
                  <input type="checkbox" checked={marcado}
                    onChange={() => setEscolhidos(prev => { const x = new Set(prev); x.has(l.id) ? x.delete(l.id) : x.add(l.id); return x })} />
                  <span style={{ flex: 1 }}>{prod.Nome || l.produto_id}</span>
                  <span style={{ fontFamily: 'monospace', fontSize: 11, color: C.textMuted }}>{prod.EAN}</span>
                </label>
              )
            })}
          </div>
        )
      })()}

      {/* O QUE ELE PEDIU E AINDA NAO FOI ACEITE.
          Sem isto, pedia um artigo, recebia uma mensagem e ficava a olhar para
          uma lista vazia — sem saber se o pedido se perdeu. Um pedido que nao
          se ve e um pedido que se repete. */}
      {!ehAdmin && propostos.length > 0 && (
        <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, padding: '12px 14px', marginBottom: 12 }}>
          <strong style={{ fontSize: 12.5, color: '#92400e' }}>
            {propostos.length === 1 ? 'Pediste 1 artigo' : `Pediste ${propostos.length} artigos`} — à espera de confirmação
          </strong>
          {propostos.map(l => (
            <div key={l.id} style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 6, fontSize: 13 }}>
              <span style={{ flex: 1 }}>
                {produtos.get(l.produto_id)?.Nome || '—'}
                <span style={{ fontFamily: 'monospace', fontSize: 11, color: C.textMuted, marginLeft: 8 }}>{produtos.get(l.produto_id)?.EAN}</span>
              </span>
              <button onClick={() => remover(l.id)} style={{ padding: '3px 9px', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 11, color: C.textMuted }}>desistir</button>
            </div>
          ))}
          <div style={{ fontSize: 11.5, color: '#92400e', marginTop: 6 }}>
            Assim que os preços estiverem prontos, recebes um email.
          </div>
        </div>
      )}

      {!ehAdmin && activos.length > 0 && visiveisAoCliente.length === 0 && (
        <div style={{ background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, padding: '14px 16px', marginBottom: 14, fontSize: 13.5, color: '#92400e' }}>
          <Clock size={14} style={{ verticalAlign: '-2px', marginRight: 6 }} />
          Os preços estão a ser actualizados. Assim que estiverem prontos recebes um email — normalmente à segunda-feira.
        </div>
      )}

      {paraMostrar.length > 0 && (
        <div style={{ overflowX: 'auto', background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead><tr style={{ background: C.bg }}>
              <th style={{ padding: '8px 10px', textAlign: 'left', fontSize: 10, color: C.textMuted, textTransform: 'uppercase' }}>Artigo</th>
              {/* SO DO LADO DO ADMIN, POR AGORA.
                  Isto e o `Produtos.preco` — o preco de catalogo, sem o desconto
                  do perfil nem a conta dos portes. O Ruben tem 10%: mostrar-lhe
                  este numero era inflacionar-lhe o custo num ecra feito para lhe
                  mostrar a margem, ou seja, argumentar contra a propria venda.
                  A regra certa vive dentro do Catalogo.jsx e so la; copia-la
                  para aqui era pôr dois donos na mesma conta. Volta quando essa
                  regra for uma funcao so, usada pelos dois ecras. */}
              <th style={{ padding: '8px 10px', textAlign: 'right', fontSize: 10, color: C.textMuted, textTransform: 'uppercase' }}>{ehAdmin ? 'Preço dele' : 'O teu preço'}</th>
              <th style={{ padding: '8px 10px', textAlign: 'right', fontSize: 10, color: C.textMuted, textTransform: 'uppercase' }}>Kaufland ES</th>
              <th style={{ padding: '8px 10px', textAlign: 'right', fontSize: 10, color: C.textMuted, textTransform: 'uppercase' }}>Amazon ES</th>
              <th style={{ padding: '8px 10px', textAlign: 'right', fontSize: 10, color: C.textMuted, textTransform: 'uppercase' }}>Idealo ES</th>
              <th style={{ padding: '8px 10px', textAlign: 'center', fontSize: 10, color: C.textMuted, textTransform: 'uppercase' }}>{ehAdmin ? 'Acções' : ''}</th>
            </tr></thead>
            <tbody>
              {paraMostrar.map(l => {
                const prod = produtos.get(l.produto_id) || {}
                const p = precos.get(l.id) || {}
                const r = rascunho[l.id] || {}
                const setR = (campo, v) => setRascunho(prev => ({ ...prev, [l.id]: { ...(prev[l.id] || {}), [campo]: v } }))
                const idadeA = corDaIdade(p.amazon_es?.lido_em)
                const idadeI = corDaIdade(p.idealo_es?.lido_em)
                return (
                  <tr key={l.id} style={{ borderTop: `1px solid ${C.border}`, verticalAlign: 'top' }}>
                    <td style={{ padding: '10px' }}>
                      <div style={{ fontWeight: 600, color: C.text }}>{prod.Nome || '—'}</div>
                      <div style={{ fontSize: 11, color: C.textMuted, fontFamily: 'monospace' }}>{prod.EAN}</div>
                      {ehAdmin && aRever.has(l.id) && (() => {
                        const r = aRever.get(l.id)
                        return (
                          <div style={{ marginTop: 3, fontSize: 10.5, fontWeight: 700, color: '#92400e',
                                        background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 4,
                                        padding: '2px 6px', display: 'inline-block' }}>
                            ⚠ rever — o Kaufland {r.var < 0 ? 'desceu' : 'subiu'} {Math.abs(r.var * 100).toFixed(0)}%
                            desde que escreveste ({fmt(r.de)} → {fmt(r.para)} €)
                          </div>
                        )
                      })()}
                      {ehAdmin && (
                        <div style={{ marginTop: 6, display: 'grid', gap: 4 }}>
                          <input defaultValue={l.amazon_url || ''} placeholder="link da Amazon ES"
                            onBlur={e => setR('amazon_url', e.target.value)}
                            style={{ padding: '3px 6px', border: `1px solid ${C.border}`, borderRadius: 4, fontSize: 11, width: 260 }} />
                          <input defaultValue={l.idealo_url || ''} placeholder="link do Idealo ES"
                            onBlur={e => setR('idealo_url', e.target.value)}
                            style={{ padding: '3px 6px', border: `1px solid ${C.border}`, borderRadius: 4, fontSize: 11, width: 260 }} />
                        </div>
                      )}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', fontFamily: 'monospace' }}>
                      {fmt(precoUnitarioB2B({ produto: prod, perfil: perfilCliente, fornecedor: fornecedores.get(prod.fornecedor_id), portesUn }))} €
                    </td>

                    {/* Kaufland — lido sozinho 2x por dia, igual nos dois lados.
                        Nao ha campo para escrever: o que e automatico nao se
                        escreve a mao, senao um dia alguem corrige um numero e
                        a corrida seguinte apaga-lhe a correccao. */}
                    <td style={{ padding: '10px', textAlign: 'right' }}>
                      <div style={{ fontFamily: 'monospace', fontWeight: 700 }}>{fmt(p.kaufland_es?.preco)} €</div>
                      {p.kaufland_es?.vendedor && (
                        <div style={{ fontSize: 10.5, color: p.kaufland_es?.nota ? C.success : C.textMuted }}>
                          {p.kaufland_es.nota ? 'Buy Box nossa' : p.kaufland_es.vendedor}
                          {p.kaufland_es.stock != null && ` · ${p.kaufland_es.stock} un`}
                        </div>
                      )}
                      {p.kaufland_es?.url && <Atalho href={p.kaufland_es.url} titulo="ver no Kaufland ES">ver lá</Atalho>}
                      <div style={{ fontSize: 10.5, color: corDaIdade(p.kaufland_es?.lido_em).cor, marginTop: 2 }}>
                        {corDaIdade(p.kaufland_es?.lido_em).texto}
                      </div>
                    </td>

                    {/* Amazon */}
                    <td style={{ padding: '10px', textAlign: 'right' }}>
                      {ehAdmin ? (
                        <div style={{ display: 'grid', gap: 4, justifyItems: 'end' }}>
                          <input defaultValue={p.amazon_es?.preco ?? ''} placeholder={fmt(p.amazon_es?.preco)}
                            onChange={e => setR('amazon_es', e.target.value)}
                            style={{ width: 90, padding: '4px 6px', border: `1px solid ${C.border}`, borderRadius: 4, fontSize: 13, textAlign: 'right', fontFamily: 'monospace' }} />
                          <label style={{ fontSize: 10.5, color: C.textMuted, display: 'flex', alignItems: 'center', gap: 3 }}>
                            <input type="checkbox" defaultChecked={!!p.amazon_es?.amazon_bb_propria} onChange={e => setR('amazon_bb_propria', e.target.checked)} />
                            vendido pela Amazon
                          </label>
                          {l.amazon_url
                            ? <Atalho href={l.amazon_url} titulo="abrir o artigo na Amazon ES">abrir</Atalho>
                            : (
                              <span style={{ display: 'flex', gap: 6, fontSize: 10.5, color: C.textMuted, whiteSpace: 'nowrap' }}>
                                procurar
                                <Atalho href={procurarAmazon(prod.EAN)} titulo="procurar este EAN na Amazon ES">EAN</Atalho>
                                ·
                                <Atalho href={procurarAmazonNome(prod.Nome)} titulo="procurar pelo nome na Amazon ES — resulta melhor quando o EAN nao esta na ficha">nome</Atalho>
                              </span>
                            )}
                        </div>
                      ) : (
                        <>
                          <div style={{ fontFamily: 'monospace', fontWeight: 700 }}>{fmt(p.amazon_es?.preco)} €</div>
                          {p.amazon_es?.amazon_bb_propria && (
                            <div style={{ fontSize: 10.5, color: C.danger }}><AlertTriangle size={10} style={{ verticalAlign: '-1px' }} /> vendido pela Amazon</div>
                          )}
                          {l.amazon_url && <Atalho href={l.amazon_url} titulo="ver na Amazon ES">ver lá</Atalho>}
                        </>
                      )}
                      <div style={{ fontSize: 10.5, color: idadeA.cor, marginTop: 2 }}>{idadeA.texto}</div>
                    </td>

                    {/* Idealo */}
                    <td style={{ padding: '10px', textAlign: 'right' }}>
                      {ehAdmin ? (
                        <div style={{ display: 'grid', gap: 4, justifyItems: 'end' }}>
                          <input defaultValue={p.idealo_es?.preco ?? ''} placeholder={fmt(p.idealo_es?.preco)}
                            onChange={e => setR('idealo_es', e.target.value)}
                            style={{ width: 90, padding: '4px 6px', border: `1px solid ${C.border}`, borderRadius: 4, fontSize: 13, textAlign: 'right', fontFamily: 'monospace' }} />
                          {l.idealo_url
                            ? <Atalho href={l.idealo_url} titulo="abrir o artigo no Idealo ES">abrir</Atalho>
                            : (
                              <span style={{ display: 'flex', gap: 6, fontSize: 10.5, color: C.textMuted, whiteSpace: 'nowrap' }}>
                                procurar
                                <Atalho href={procurarIdealo(prod.EAN)} titulo="procurar este EAN dentro do idealo.es, pelo Google">EAN</Atalho>
                                ·
                                <Atalho href={procurarIdealoNome(prod.Nome)} titulo="procurar pelo nome dentro do idealo.es, pelo Google">nome</Atalho>
                              </span>
                            )}
                        </div>
                      ) : (
                        <>
                          <div style={{ fontFamily: 'monospace', fontWeight: 700 }}>{fmt(p.idealo_es?.preco)} €</div>
                          {l.idealo_url && <Atalho href={l.idealo_url} titulo="ver no Idealo ES">ver lá</Atalho>}
                        </>
                      )}
                      <div style={{ fontSize: 10.5, color: idadeI.cor, marginTop: 2 }}>{idadeI.texto}</div>
                    </td>

                    <td style={{ padding: '10px', textAlign: 'center' }}>
                      {ehAdmin ? (
                        <div style={{ display: 'grid', gap: 4, justifyItems: 'center' }}>
                          <button onClick={() => guardarLinha(l)} disabled={aGuardar}
                            style={{ padding: '4px 10px', border: 'none', borderRadius: 5, background: C.primary, color: '#fff', cursor: 'pointer', fontSize: 12 }}>Guardar</button>
                          <button onClick={() => remover(l.id)}
                            style={{ padding: '3px 8px', border: `1px solid ${C.border}`, borderRadius: 5, background: C.surface, cursor: 'pointer', fontSize: 11, color: C.danger }}>
                            <Trash2 size={11} style={{ verticalAlign: '-1px' }} /> tirar
                          </button>
                          {l.pedido_actualizacao_em && (
                            <span style={{ fontSize: 10, color: C.danger }}>pediu actualização</span>
                          )}
                        </div>
                      ) : (
                        <div style={{ display: 'grid', gap: 4, justifyItems: 'center' }}>
                          <button onClick={() => pedirActualizacao(l.id)}
                            style={{ padding: '4px 10px', border: `1px solid ${C.border}`, borderRadius: 5, background: C.surface, cursor: 'pointer', fontSize: 11.5 }}>
                            pedir actualização
                          </button>
                          <button onClick={() => remover(l.id)}
                            style={{ padding: '3px 8px', border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 11, color: C.textMuted }}>tirar da lista</button>
                        </div>
                      )}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}

      {!ehAdmin && linhas.length === 0 && (
        <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8, padding: '18px 20px', marginBottom: 12 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: C.text, marginBottom: 4 }}>Ainda não escolheste nenhum artigo</div>
          <div style={{ fontSize: 13, color: C.textMuted, lineHeight: 1.6 }}>
            Escolhe até 15 artigos do catálogo aqui em baixo. Para cada um passas a ver o que o mercado
            espanhol está a pedir — Kaufland, Amazon e Idealo — com o dia em que cada preço foi recolhido.
          </div>
        </div>
      )}

      {/* ── Acrescentar ─────────────────────────────────────────────────── */}
      <div style={{ marginTop: 14, background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8, padding: '12px 14px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <strong style={{ fontSize: 13 }}>Acrescentar artigo</strong>
          <span style={{ fontSize: 11.5, color: ocupados >= 15 ? C.danger : C.textMuted }}>{ocupados} de 15 lugares</span>
          <input value={procura} onChange={e => setProcura(e.target.value)} placeholder="nome do artigo ou EAN…"
            style={{ flex: 1, minWidth: 220, padding: '6px 10px', border: `1px solid ${C.border}`, borderRadius: 6, fontSize: 13 }} />
        </div>
        {candidatos.length > 0 && (
          <div style={{ marginTop: 8, display: 'grid', gap: 3 }}>
            {candidatos.map(p => (
              <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 12.5, padding: '4px 0', borderTop: `1px solid ${C.border}` }}>
                <span style={{ flex: 1 }}>{p.Nome}</span>
                <span style={{ fontFamily: 'monospace', color: C.textMuted, fontSize: 11 }}>{p.EAN}</span>
                <span style={{ fontFamily: 'monospace', fontSize: 12, fontWeight: 700 }}>
                  {fmt(precoUnitarioB2B({ produto: p, perfil: perfilCliente, fornecedor: fornecedores.get(p.fornecedor_id), portesUn }))} €
                </span>
                <button onClick={() => propor(p.id)} disabled={aGuardar || ocupados >= 15}
                  style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '3px 9px', border: 'none', borderRadius: 5, background: C.primary, color: '#fff', cursor: 'pointer', fontSize: 11.5 }}>
                  <Plus size={11} /> {ehAdmin ? 'acrescentar' : 'pedir'}
                </button>
              </div>
            ))}
          </div>
        )}
        {procura.trim().length >= 3 && candidatos.length === 0 && (
          <div style={{ marginTop: 8, fontSize: 12, color: C.textMuted }}>Nenhum artigo com esse nome ou EAN.</div>
        )}
      </div>

      {!ehAdmin && (
        <p style={{ fontSize: 11.5, color: C.textMuted, marginTop: 12, lineHeight: 1.6 }}>
          O Kaufland é lido sozinho, duas vezes por dia. Os preços da Amazon e do Idealo são recolhidos à mão, por isso mostram sempre o dia em que foram vistos.
          Ao fim de {DIAS_VIVE} dias deixam de aparecer — mais vale não ter número nenhum do que decidir com um velho.
          Se precisares de um valor fresco antes disso, carrega em <strong>pedir actualização</strong>.
        </p>
      )}
    </div>
  )
}
